import {FileMimeTypeModel} from '@shared/models/file-mime-type.model';

export interface FileModel {
	uuid?: string;
	file_manager_id?: string;
	file_name?: string;
	blob_name?: string;
	file_size?: number;
	blob_type?: string;
	mime_type?: FileMimeTypeModel;
	description?: ClaimsFileType | any;
	created_at?: any;
	file_manager_name?: string;
	file_content?: any;
	hidden?: boolean;
	validate?: boolean;
	blob_url?: string;

	thumbnail_id?: string;
	user: string;
	user_name: string;
	user_first_name?: string;
	user_last_name?: string;
	blob_size?: number;
	external_id?: any;
	isLp?:boolean;
}

export enum ClaimsFileType {
	CAI = 'CAI',
	PHOTO = 'PHOTO',
	OTHER = 'OTHER',
	COMPLAINT = 'COMPLAINT',
	ACCIDENTAL_DECLARATION = 'ACCIDENTAL_DECLARATION',
	CRASH_REPORT = 'CRASH_REPORT',
	WITNESS_DECLARATION = 'WITNESS_DECLARATION',
	REFERENCE_ER = 'REFERENCE_ER',
	ADDITIONAL_COST = 'ADDITIONAL_COST',
	DOGE = 'DOGE',
	PAI = 'PAI'
}

export class ClaimsWorkingAttachment {
	attachment_type: any;
	blob_name: any;
	blob_type: any;
	description: any;
	external_id: any;
	file_name: any;
	file_size: any;
	id: any;
	mime_type: any;
	resource_id: any;
	resource_type: any;
	status: any;
	thumbnail_id: any;
	uuid: any;
	created_at: any;
	user_first_name: any;

	constructor(file: any) {
		this.attachment_type = null;
		this.blob_name = file.file_manager_name;
		this.blob_type = file.blob_name;
		this.description = file.description;
		this.external_id = file.external_id;
		this.file_name = file.file_manager_name;
		this.file_size = file.blob_size;
		this.id = null;
		this.mime_type = file.mime_type;
		this.resource_id = null;
		this.resource_type = file.blob_name;
		this.status = null;
		this.thumbnail_id = file.thumbnail_id;
		this.uuid = file.file_manager_id;
		this.created_at = file.created_at;
		this.user_first_name = file.user_name;
	}
}
